export function normalizeEvidenceSourceType(value) {
  const raw = String(value || '').trim().toLowerCase();
  if (raw.includes('web')) {
    return 'web';
  }
  if (raw.includes('mcp')) {
    return 'mcp';
  }
  if (raw.includes('instance_db') || raw === 'instance' || raw === 'database' || raw === 'db') {
    return 'instance_db';
  }
  return 'local';
}

function preserveObject(value) {
  return (
    value
    && typeof value === 'object'
    && !Array.isArray(value)
  ) ? value : {};
}

function preserveArray(value) {
  return Array.isArray(value) ? value : [];
}

export function preserveResourceRef(value) {
  return preserveObject(value);
}

function identityText(value) {
  return String(value || '').trim();
}

function resourceIdentityValue(row, resourceRef) {
  const resourceId = identityText(resourceRef.resource_id);
  const url = identityText(resourceRef.url || row.source_url || row.canonical_url);
  const sourceId = identityText(resourceRef.source_id || row.source_id);
  return resourceId || sourceId || url;
}

export function resolveResourceIdentity(row = {}) {
  const resourceRef = preserveResourceRef(row.resource_ref);
  const sourceType = normalizeEvidenceSourceType(resourceRef.source_type || row.source_type || row.source);
  const identity = resourceIdentityValue(row, resourceRef);
  return identity ? `${sourceType}:${identity}` : identityText(row.key);
}

export function mergeEvidenceRows(existing = {}, incoming = {}) {
  const existingResourceRef = preserveResourceRef(existing.resource_ref);
  const incomingResourceRef = preserveResourceRef(incoming.resource_ref);
  return {
    ...existing,
    ...incoming,
    key: existing.key || incoming.key,
    snippet: existing.snippet || incoming.snippet,
    matchedTerms: preserveArray(existing.matchedTerms).length
      ? existing.matchedTerms
      : preserveArray(incoming.matchedTerms),
    resource_ref: Object.keys(incomingResourceRef).length > 0
      ? { ...existingResourceRef, ...incomingResourceRef }
      : existingResourceRef,
  };
}
